import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M5194 6535 c-736 -108 -1320 -689 -1435 -1430 -18 -118 -15 -389 6
-510 26 -150 78 -322 128 -418 14 -28 15 -28 21 -5 8 31 8 103 -1 95 -3 -4 -6
-24 -5 -44 1 -35 0 -37 -13 -19 -18 23 -19 33 -5 41 6 3 10 17 10 31 0 13 5
24 10 24 6 0 10 5 10 10 0 6 -6 10 -14 10 -21 0 -25 45 -13 147 7 65 15 93 24
93 9 0 13 14 13 40 0 28 4 40 14 40 9 0 17 15 21 40 4 22 11 40 16 40 16 0 69
52 63 62 -3 5 3 12 15 15 14 4 21 14 22 32 1 14 6 -7 11 -47 5 -40 14 -85 20
-100 l10 -27 10 25 c15 38 57 121 79 157 18 29 19 37 8 99 -25 142 3 381 66
568 14 43 24 84 21 92 -3 8 0 11 10 7 9 -3 14 1 14 12 0 10 -5 13 -12 9 -8 -5
-9 -1 -5 12 5 12 -2 8 -18 -11 -14 -16 -25 -25 -25 -19 0 6 7 17 15 24 8 7 15
20 15 29 -1 22 -33 -19 -60 -76 -11 -24 -25 -43 -30 -43 -15 0 -12 109 5 188
82 392 442 681 940 758 108 16 304 18 411 3 144 -20 427 -114 449 -149 3 -5
19 -11 35 -15 17 -4 30 -10 30 -13 0 -4 20 -20 45 -35 25 -16 45 -31 45 -33 0
-7 -35 10 -59 28 -29 22 -41 15 -18 -10 9 -9 17 -36 18 -60 3 -36 6 -42 25
-42 19 0 22 -7 27 -57 6 -55 -3 -86 -20 -69 -4 4 -1 12 7 17 11 8 12 12 3 16
-7 2 -14 14 -14 26 -1 17 -2 18 -6 5 -2 -10 -11 -18 -19 -18 -24 0 -16 -22 21
-56 19 -17 35 -36 35 -42 0 -6 -16 4 -35 21 -20 18 -57 44 -83 57 -26 14 -53
31 -61 38 -24 23 -151 81 -232 107 -240 76 -544 76 -744 2 -22 -8 -49 -18 -59
-21 -10 -4 -17 -8 -15 -11 3 -2 39 7 81 20 84 27 279 58 330 53 31 -3 29 -4
-27 -22 -384 -124 -668 -392 -815 -768 -16 -43 -36 -108 -45 -145 -17 -80 -36
-216 -30 -221 2 -3 26 12 52 31 42 30 239 147 249 147 2 0 28 11 58 25 l56 25
-22 53 c-18 43 -22 72 -22 172 -1 110 1 126 28 190 38 93 76 147 156 225 118
115 303 208 499 250 76 17 92 17 141 5 63 -15 112 -33 91 -34 -10 -1 -11 -4
-2 -15 9 -10 4 -25 -23 -65 -19 -28 -29 -51 -23 -51 7 -1 1 -7 -13 -15 -25
-14 -25 -14 -2 -15 12 0 22 -4 22 -9 0 -5 19 -11 43 -14 67 -8 98 -17 165 -48
63 -29 74 -46 47 -69 -8 -7 -15 -24 -15 -37 0 -15 -10 -33 -25 -45 -18 -14
-24 -26 -20 -39 4 -12 -1 -22 -14 -31 -12 -7 -21 -21 -21 -30 0 -10 -6 -18
-13 -18 -8 0 -20 -18 -27 -40 -12 -37 -21 -45 -43 -41 -5 1 -6 -3 -3 -8 3 -5
-11 -12 -32 -16 -51 -8 -77 -25 -40 -25 15 0 29 4 32 9 3 5 18 11 33 14 100
19 259 75 377 133 56 27 81 35 84 26 2 -7 11 -20 20 -29 16 -16 16 -16 -2 -10
-18 7 -18 3 -12 -80 4 -48 12 -91 19 -95 7 -4 10 -49 9 -134 -1 -125 0 -128
24 -151 15 -14 23 -30 20 -38 -3 -8 0 -15 7 -15 8 0 6 -4 -3 -10 -13 -9 -13
-10 0 -11 8 -1 18 -1 23 0 4 0 8 -2 8 -6 9 -57 8 -63 -7 -48 -9 8 -20 13 -25
10 -14 -9 -11 -25 6 -25 8 0 15 -3 15 -8 0 -15 -76 -90 -110 -107 -51 -26
-241 -80 -425 -120 -88 -19 -214 -46 -280 -61 -65 -14 -170 -41 -232 -60 -62
-19 -120 -34 -128 -34 -33 0 -236 -101 -330 -163 -91 -61 -202 -163 -245 -227
-63 -93 -92 -183 -43 -134 16 15 18 16 21 2 3 -18 32 -33 32 -18 0 6 6 10 13
10 7 0 28 25 46 55 18 30 37 55 41 55 4 0 26 -24 49 -53 86 -112 271 -258 405
-321 328 -153 647 -175 971 -64 364 123 654 412 783 778 87 249 88 537 2 799
-23 70 -30 111 -30 169 0 135 -44 251 -149 389 -215 285 -616 503 -1025 558
-132 18 -358 18 -482 0z m946 -475 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3
6 1 10 9 10 9 0 16 -4 16 -10z m72 -102 c-6 -6 -15 -8 -19 -4 -4 4 -1 11 7 16
19 12 27 3 12 -12z m24 -205 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15
-2 -18z m104 -563 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0
10 -4 10 -10z m30 -30 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10
6 0 10 -4 10 -10z m-2530 -706 c0 -8 -19 -13 -24 -6 -3 5 1 9 9 9 8 0 15 -2
15 -3z m40 -188 c-1 -31 -1 -31 -15 9 -18 50 -18 50 0 35 8 -7 15 -27 15 -44z"/>
<path d="M4890 6160 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z"/>
<path d="M5600 5540 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M6255 5070 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4430 5022 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 -9 8 -15 8 -15 2z"/>
<path d="M4370 4981 c0 -5 7 -11 14 -14 10 -4 13 -1 9 9 -6 15 -23 19 -23 5z"/>
<path d="M4290 4899 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7130 4850 c-6 -65 -5 -78 6 -68 3 3 4 34 2 69 l-3 64 -5 -65z"/>
<path d="M7730 4686 l-125 -43 -3 -34 -3 -34 119 -62 c66 -35 122 -63 126 -63
3 0 6 15 6 34 0 25 -5 35 -20 39 -17 4 -20 14 -20 56 0 33 5 55 15 63 39 33
45 41 45 64 0 13 -3 24 -7 23 -5 0 -64 -20 -133 -43z m30 -91 c0 -19 -2 -35
-5 -35 -11 0 -75 34 -75 40 0 6 50 26 73 29 4 1 7 -15 7 -34z"/>
<path d="M2988 4713 l-38 -4 0 -58 c0 -32 3 -78 6 -103 6 -41 8 -44 31 -40 24
4 24 7 21 71 -3 65 -2 66 22 66 23 0 25 -4 28 -57 3 -54 5 -58 27 -58 24 0 25
3 25 59 0 45 4 60 16 65 27 10 34 -3 34 -70 l0 -65 28 3 c18 2 27 9 26 21 0 9
-1 53 -2 97 l-2 80 -92 -2 c-51 -1 -110 -3 -130 -5z"/>
<path d="M3180 4070 c-58 -22 -109 -40 -114 -42 -4 -2 4 -41 19 -86 21 -62 31
-82 42 -78 8 3 19 6 25 6 6 0 8 12 4 30 -3 17 -9 42 -12 58 -5 26 -3 28 78 56
46 16 87 32 91 36 9 8 -9 60 -20 59 -5 -1 -55 -18 -113 -39z"/>
<path d="M4566 4087 c-2 -7 -8 -28 -15 -48 -16 -52 -14 -217 5 -291 40 -156
153 -297 317 -396 59 -36 176 -92 192 -92 4 0 21 -6 38 -14 40 -18 118 -36
152 -36 15 0 24 -4 20 -10 -4 -6 13 -11 42 -11 l48 -2 -40 -6 c-71 -11 -3 -21
145 -21 267 0 500 55 731 171 149 74 246 143 392 280 37 36 34 47 -4 15 -17
-14 -35 -26 -40 -26 -6 0 -7 -4 -4 -10 3 -5 0 -10 -8 -10 -8 0 -18 -7 -21 -16
-3 -8 -11 -12 -17 -8 -8 5 -6 10 5 16 23 13 20 31 -4 25 -15 -4 -20 0 -20 14
0 16 -7 19 -40 19 -36 0 -40 3 -40 24 0 13 5 26 12 28 7 3 5 7 -6 11 -10 4
-15 3 -11 -3 7 -12 -15 -13 -32 -2 -8 5 8 22 46 49 65 48 231 203 216 203 -6
-1 -39 -22 -73 -49 -191 -145 -440 -250 -667 -282 -44 -6 -88 -15 -97 -20 -10
-5 -29 -9 -43 -9 -15 0 -24 -4 -20 -10 4 -6 -18 -10 -59 -10 -71 0 -90 -16
-28 -23 20 -3 4 -3 -37 -1 -41 1 -77 7 -80 13 -3 5 -20 13 -36 17 -42 10 -60
25 -43 35 9 6 5 9 -12 9 -40 0 -186 45 -301 93 -181 75 -342 181 -482 319 -43
42 -80 71 -81 65z m1779 -417 c3 -5 -3 -10 -14 -10 -11 0 -23 -4 -26 -10 -3
-5 -12 -10 -18 -10 -7 0 -1 9 13 20 29 22 36 24 45 10z"/>
<path d="M7495 4078 c-2 -7 -18 -52 -36 -100 -18 -49 -31 -90 -28 -92 2 -2 14
-6 26 -10 18 -6 23 -1 33 29 6 19 13 35 15 35 2 0 45 -16 96 -35 50 -20 93
-34 95 -32 2 2 6 17 10 33 5 28 4 30 -73 57 -109 38 -109 38 -93 77 11 27 11
33 -1 41 -20 12 -39 11 -44 -3z"/>
<path d="M3947 4060 c3 -11 9 -20 13 -20 5 0 6 9 3 20 -3 11 -9 20 -13 20 -5
0 -6 -9 -3 -20z"/>
<path d="M3986 4002 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M4010 3966 c0 -3 5 -17 12 -31 11 -25 28 -34 28 -15 0 6 -4 10 -10
10 -5 0 -10 6 -10 14 0 8 -4 18 -10 21 -5 3 -10 4 -10 1z"/>
<path d="M4060 3881 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M4100 3835 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M4141 3791 c-10 -6 -10 -10 -1 -16 13 -8 24 -1 19 14 -3 6 -10 7 -18
2z"/>
<path d="M4155 3750 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4203 3706 c33 -31 52 -34 35 -6 -7 11 -16 20 -20 20 -3 0 -15 3 -25
6 -12 4 -9 -2 10 -20z"/>
<path d="M4274 3666 c-18 -14 -18 -16 11 -46 45 -49 185 -160 201 -160 7 0 17
-6 21 -14 8 -14 53 -41 53 -31 0 5 -33 45 -61 75 -9 10 -25 31 -35 49 -19 32
-48 41 -57 17 -6 -15 6 -29 33 -39 12 -4 12 -6 -2 -6 -26 -1 -50 28 -43 53 4
14 3 17 -3 8 -9 -13 -42 -6 -42 9 0 5 -5 9 -10 9 -6 0 -22 12 -35 26 -20 21
-22 30 -14 41 17 20 6 25 -17 9z"/>
<path d="M6560 3639 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4368 3593 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3445 3480 c-66 -14 -118 -31 -116 -36 13 -32 31 -46 54 -40 20 5 29
-2 57 -40 29 -40 31 -48 20 -69 -10 -19 -9 -27 5 -49 10 -14 19 -26 20 -26 5
0 145 230 145 238 -1 14 -39 52 -52 51 -7 -1 -67 -14 -133 -29z m105 -47 c-1
-5 -12 -21 -26 -38 l-24 -30 -20 25 c-10 14 -16 28 -12 32 15 14 82 23 82 11z"/>
<path d="M7161 3432 l-19 -28 64 -114 c35 -63 68 -116 73 -118 5 -2 16 7 24
19 12 16 13 27 5 44 -16 35 35 104 76 105 29 0 73 38 59 50 -5 4 -60 20 -123
35 -63 14 -120 28 -127 30 -7 2 -21 -8 -32 -23z m127 -63 c23 -9 23 -9 5 -34
-23 -32 -27 -31 -52 9 -32 51 -29 53 47 25z"/>
<path d="M3902 2973 l-72 -97 21 -21 21 -20 26 34 c15 19 37 46 49 60 l22 26
1 -96 c0 -91 1 -98 24 -112 22 -15 25 -15 38 2 7 10 41 55 76 100 35 45 60 86
57 91 -3 5 -15 14 -25 20 -16 9 -24 2 -57 -45 -21 -30 -41 -55 -45 -55 -5 0
-8 43 -8 95 0 83 -2 96 -19 105 -11 5 -24 10 -29 10 -5 0 -41 -44 -80 -97z"/>
<path d="M6654 2948 c-32 -23 -61 -43 -64 -45 -2 -2 0 -10 5 -17 6 -8 39 -55
74 -105 l64 -92 26 17 c135 87 165 172 86 251 -28 28 -40 33 -82 33 -42 0 -59
-6 -109 -42z m146 -40 c27 -29 26 -81 -2 -108 -12 -11 -27 -20 -34 -20 -14 0
-84 92 -84 110 0 41 87 53 120 18z"/>
<path d="M4530 2595 l0 -135 26 -10 c14 -6 29 -10 35 -10 5 0 30 32 56 72 l48
71 3 -91 3 -91 30 -6 c17 -4 34 -3 38 1 34 41 153 205 150 208 -2 2 -17 7 -34
10 -29 6 -32 3 -83 -76 l-54 -83 7 101 c7 100 7 101 -17 107 -41 12 -46 8 -93
-68 -26 -41 -50 -75 -53 -75 -3 0 -2 42 2 94 3 52 3 97 -1 99 -5 2 -20 7 -35
11 l-28 6 0 -135z"/>
<path d="M6058 2658 c-32 -11 -58 -25 -58 -31 0 -7 16 -61 36 -120 35 -104 37
-108 63 -105 23 3 26 7 26 43 0 33 4 41 21 43 12 2 35 -8 51 -22 27 -23 34
-25 63 -14 l33 11 -38 31 c-34 29 -37 34 -25 55 16 30 6 78 -22 108 -27 29
-71 29 -150 1z m106 -47 c21 -23 12 -47 -27 -68 -29 -14 -31 -14 -44 3 -8 11
-13 30 -11 44 3 21 19 32 59 39 3 1 13 -7 23 -18z"/>
<path d="M5368 2442 c-27 -65 -48 -124 -48 -130 0 -7 13 -12 28 -12 21 0 32 7
40 25 10 22 18 25 68 25 48 0 57 -3 61 -20 6 -21 43 -36 67 -27 11 4 2 33 -42
131 l-55 126 -36 0 -36 0 -47 -118z m105 -2 l15 -40 -34 0 c-19 0 -34 3 -34 7
0 14 24 73 30 73 4 0 14 -18 23 -40z"/>
</g>
</svg>








    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
